export default class AuditTrailServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.auditTrailEndpoint, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.auditTrailEndpoint}/export`, {
      params,
      responseType: "blob"
    })
  }
}
